export function formatBirthDateDdMmYyyy(dateStr?: string | null): string {
  if (!dateStr) return "—";
  const asDate = new Date(dateStr);
  if (!isNaN(asDate.getTime())) {
    const dd = String(asDate.getDate()).padStart(2, "0");
    const mm = String(asDate.getMonth() + 1).padStart(2, "0");
    const yyyy = asDate.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }
  const m = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  return String(dateStr);
}

export function getTimeZoneOffsetMinutes(date: Date, timeZone: string): number | null {
  try {
    const dtf = new Intl.DateTimeFormat("en-US", {
      timeZone,
      calendar: "iso8601",
      numberingSystem: "latn",
      year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
    });
    const parts = dtf.formatToParts(date);
    const map: Record<string, number> = {};
    for (const p of parts) {
      if (p.type === "year" || p.type === "month" || p.type === "day" || p.type === "hour" || p.type === "minute" || p.type === "second") {
        map[p.type] = Number(p.value);
      }
    }
    if (map.year == null) return null;
    const asUTC = Date.UTC(map.year, (map.month || 1) - 1, map.day || 1, map.hour || 0, map.minute || 0, map.second || 0);
    return Math.round((asUTC - date.getTime()) / 60000);
  } catch {
    return null;
  }
}

export function formatDiffLabel(mins: number): string {
  if (!Number.isFinite(mins) || mins === 0) return "+0 horas";
  const sign = mins > 0 ? "+" : "-";
  const abs = Math.abs(mins);
  const hours = Math.floor(abs / 60);
  const minutes = abs % 60;
  if (minutes === 0) return `${sign}${hours} horas`;
  return `${sign}${hours} h ${minutes} m`;
}

export function formatDateInTimezone(iso?: string, tz?: string): { date: string; day: string; time: string } {
  if (!iso) return { date: "—", day: "—", time: "—" };
  const d = new Date(iso);
  const opts = tz ? { timeZone: tz } : undefined;
  const date = d.toLocaleDateString("es-AR", { day: "2-digit", month: "long", year: "numeric", ...opts });
  const dayRaw = d.toLocaleDateString("es-AR", { weekday: "long", ...opts });
  const day = dayRaw ? dayRaw.charAt(0).toUpperCase() + dayRaw.slice(1) : dayRaw;
  const time = d.toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit", ...opts });
  return { date, day, time };
}
